<template>
  <div class="p-5 flex flex-col">
    <p class="font-semibold text-3xl">
      {{ this.$route.meta.title }}
    </p>
    <vs-row
      vs-w="12"
      class="my-5 filter-container flex justify-between"
    >
      <vs-col vs-w="1">
        <p class="font-semibold">
          Filter
        </p>
      </vs-col>
      <vs-col vs-w="3" />
      <vs-col
        vs-w="8"
        class="flex justify-end"
      >
        <div class="flex flex-row gap-x-4 items-stretch">
          <div class="flex items-center">
            <div class="w-full date-picker-wrapper">
              <date-picker
                type="month"
                format="MMM YYYY"
                value-type="format"
                placeholder="Select Month"
                v-model="filters.month_year"
                :clearable="false"
              />
            </div>
          </div>
          <div class="flex items-center">
            <vs-button
              type="border"
              color="primary"
              class="self-center font-semibold"
              style="min-width: 100px"
              @click="resetFilters"
            >
              Reset
            </vs-button>
          </div>
          <div class="flex items-center">
            <vs-button
              class="self-center font-semibold"
              color="secondary"
              style="min-width: 100px;"
              @click="isDownload = true"
            >
              Export
            </vs-button>
          </div>
        </div>
      </vs-col>
    </vs-row>
    <performance-chart
      class="mt-5"
      :chart-data="tugBargePerformanceChartData"
      :month-year="filters.month_year"
      :loading="isChartBusy"
    />
    <div class="p-5 flex flex-col mt-5 bg-white rounded-md">
      <data-table
        class="mt-6"
        :table-header="tableHeaders"
        :table-data="tugBargePerformanceData"
        :sort-by="filters.sort_by"
        :sort-dir="filters.sort_dir"
        body-height="auto"
        :loading="isBusy"
      >
        <template #no="{ index }">
          <div class="flex flex-row">
            {{ (currentPage - 1) * pageSize + index + 1 }}
          </div>
        </template>
        <template #action="{ row }">
          <div class="flex flex-row gap-x-3">
            <div
              v-if="isUserCanAccessMenu(permission.name, 'view')"
              class="flex items-center justify-center icon-transparent-bg"
              @click="handleView(row)"
            >
              <img
                :src="require('@/assets/shipo-icon-see.svg')"
                class="w-8 h-8"
                alt="view"
              >
            </div>
            <div
              v-if="isUserCanAccessMenu(permission.name, 'edit')"
              class="flex items-center justify-center icon-transparent-bg"
              @click="handleEdit(row)"
            >
              <img
                :src="require('@/assets/shipo-icon-edit.svg')"
                class="w-8 h-8"
                alt="edit"
              >
            </div>
          </div>
        </template>
        <template #owner_name="{ row }">
          {{ row.owner_name }}
        </template>
        <template #operation_score="{ row }">
          {{
            row.operation_score !== null && row.operation_score !== undefined
              ? row.operation_score >= 0
                ? row.operation_score.toFixed(2)
                : `(${Math.abs(row.operation_score).toFixed(2)})`
              : ''
          }}
        </template>
        <template #availability_score="{ row }">
          {{
            row.availability_score !== null && row.availability_score !== undefined
              ? row.availability_score >= 0
                ? row.availability_score.toFixed(2)
                : `(${Math.abs(row.availability_score).toFixed(2)})`
              : ''
          }}
        </template>
        <template #overall_score="{ row }">
          {{
            row.overall_score !== null && row.overall_score !== undefined
              ? row.overall_score >= 0
                ? row.overall_score.toFixed(2)
                : `(${Math.abs(row.overall_score).toFixed(2)})`
              : ''
          }}
        </template>
      </data-table>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import {mapGetters} from "vuex";

import DataTable from "@/components/dataTable";
import DatePicker from "@/components/datePicker";
import { PAGE_TITLE } from "@/fixtures/Constants";
import downloadUtils from '@/utils/downloadUtils'

import PerformanceChart from "./performanceChart.vue";

export default {
  metaInfo() {
    return {
      title: `${PAGE_TITLE} ${this.$route.meta.title}`
    }
  },
  components: {
    DataTable,
    DatePicker,
    PerformanceChart
  },
  data() {
    return {
      tableHeaders: [
        { key: 'no', label: 'No.', sortable: false, width: '50px' },
        { key: 'action', label: 'Action', sortable: false, width: '120px' },
        { key: 'owner_name', label: 'Tug Owner' },
        { key: 'operation_score', label: 'Operation Performance' },
        { key: 'availability_score', label: 'Availability' },
        { key: 'overall_score', label: 'Overall Score' }
      ],
      tugBargePerformanceData: [],
      filters: {
        month_year: moment().format('MMM YYYY')
      },
      isDownload: false,
      isBusy: false,
      isChartBusy: false,
      tugBargePerformanceChartData: null
    }
  },
  computed: {
    ...mapGetters({
      currentPage: 'Table/currentPage',
      pageSize: 'Table/pageSize',
      tugBargesPerformance: 'TugBargesCombination/tugBargesPerformance',
      tugBargesPerformanceChart: 'TugBargesCombination/tugBargesPerformanceChart',
      tugBargesPerformanceFiles: 'TugBargesCombination/tugBargesPerformanceFiles'
    }),
    permission() {
      return { page: this.$route.meta.permission.page, name: this.$route.meta.permission.name }
    }
  },
  mounted() {
    this.fetchTugBargePerformance()
    this.fetchTugBargePerformanceChart()
  },
  watch: {
    filters: {
      deep: true,
      handler() {
        this.fetchTugBargePerformance()
        this.fetchTugBargePerformanceChart()
      }
    },
    tugBargesPerformance: {
      handler(val) {
        if (val) {
          this.tugBargePerformanceData = val
        }
      }
    },
    tugBargesPerformanceChart: {
      handler(val) {
        if (val) {
          this.tugBargePerformanceChartData = val
        }
      }
    },
    isDownload: {
      handler(val) {
        if (!!val) {
          this.downloadTugBargePerformance();
        }
      }
    },
    tugBargesPerformanceFiles: {
      handler(val) {
        if (val && val.headers && val.data) {
          downloadUtils(val, `Report Tug Barge Performance ${this.moment(this.filters.month_year).format('MMM YYYY')}.xlsx`)
          this.$store.dispatch('TugBargesCombination/resetTugBargesPerformanceFiles')
          this.isDownload = false
        }
      }
    }
  },
  methods: {
    async fetchTugBargePerformance() {
      try {
        this.isBusy = true
        const payload = {
          month_year: moment(this.filters.month_year).format('MM-YYYY'),
          sort_by: this.filters.sort_by,
          sort_dir: this.filters.sort_dir
        }
        await this.$store.dispatch('TugBargesCombination/fetchTugBargesPerformance', payload)
        this.isBusy = false
      } catch (e) {
        this.isBusy = false
        this.showFailedNotification(this, 'Failed to fetch tug barge performance list, please try again')
      } finally {
        this.isBusy = false
      }
    },
    async fetchTugBargePerformanceChart() {
      try {
        this.isChartBusy = true
        const payload = {
          month_year: moment(this.filters.month_year).format('MM-YYYY')
        }
        await this.$store.dispatch('TugBargesCombination/fetchTugBargesPerformanceChart', payload)
      } catch (e) {
        this.showFailedNotification(this, 'Failed to fetch tug barge performance chart, please try again')
      } finally {
        this.isChartBusy = false
      }
    },
    sort(sortBy, sortDir) {
      this.filters.sort_by = sortBy
      this.filters.sort_dir = sortDir
      this.fetchTugBargePerformance()
    },
    async handleView(row) {
      await this.$router.push({ name: 'TugBargePerformanceDetail', params: { id: row.owner_id }, query: { isEditing: false, month_year: this.filters.month_year } })
    },
    async handleEdit(row) {
      await this.$router.push({ name: 'TugBargePerformanceDetail', params: { id: row.owner_id }, query: { isEditing: true, month_year: this.filters.month_year } })
    },
    resetFilters() {
      this.filters = {
        sort_by: 'overall_score',
        sort_dir: 'desc',
        month_year: moment().format('MMM YYYY')
      }
      this.fetchTugBargePerformance()
    },
    async downloadTugBargePerformance() {
      try {
        this.isBusy = true
        await this.$store.dispatch('TugBargesCombination/downloadTugBargesPerformance', {
          month_year: this.filters.month_year ? this.moment(this.filters.month_year).format('MM-YYYY') : null
        }, {
          headers: {
            accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
          },
          resposnseType: 'blob'
        })
        this.isBusy = false
        this.isDownload = false
      } catch (error) {
        this.isBusy = false
        this.isDownload = false
        this.showFailedNotification(this, 'Failed to download Tug Barge Performance, please try again')
      }
    }
  },
  beforeCreate() {
    this.$store.dispatch('Table/resetConfig')
  }
}
</script>

<style lang="scss" scoped>
.filter-container {
  padding: 1.25rem;
  margin-top: 1.25rem;
  display: flex;
  flex-direction: row;
  align-items: center;
  background: #ffffff;
  border-radius: 0.5rem;
}

.icon-transparent-bg {
  cursor: pointer;
  min-width: 2rem;
  height: 2rem;
  background-color: #493493;
  border-radius: 0.5rem;
}
</style>
